import { actionTypes as documentEditorActionTypes } from "Areas/Documents/documentEditorPanel";
import documentsActionTypes from "Areas/Documents/redux/actionTypes";
import { actionTypes as projectEditorActionTypes } from "Areas/Projects/projectEditorPanel";
import projectsActionTypes from "Areas/Projects/redux/actionTypes";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import flatMap from "lodash/flatMap";
import map from "lodash/map";
import omit from "lodash/omit";
import reject from "lodash/reject";
import values from "lodash/values";
import { actionTypes as workSpaceEditorActionTypes } from "../../workSpaceEditorPanel";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: { data: {}, tab: 0 }
};
export default createReducer(initialState, {
    [actionTypes.GET_WORK_SPACE_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data[${payload.Id}]`, {
        ...payload,
        Projects: map(payload.Projects, project => ({
            ...project,
            Updated: Math.max(project.Updated || 0, ...map(project.Documents, "Updated"))
        }))
    }),
    [actionTypes.SET_TAB]: (state, { tab }) => set(state, `[${NAMESPACE}].tab`, tab),
    [workSpaceEditorActionTypes.SAVE_WORK_SPACE_COMPLETED]: (state, { payload }) => {
        const resultData = state[NAMESPACE].data[payload.Id]
            ? { ...state[NAMESPACE].data[payload.Id], ...omit(payload, "Projects") }
            : payload;
        return set(state, `[${NAMESPACE}].data[${payload.Id}]`, resultData);
    },
    [projectEditorActionTypes.SAVE_PROJECT_COMPLETED]: (state, { payload }) => {
        var _a;
        const prevProjects = (_a = state[NAMESPACE].data[payload.WorkSpaceId]) === null || _a === void 0 ? void 0 : _a.Projects;
        if (!prevProjects)
            return state;
        const prevIndex = findIndex(prevProjects, ["Id", payload.Id]);
        const prevData = prevIndex !== -1 ? prevProjects[prevIndex] : undefined;
        const resultData = {
            ...(prevData || {}),
            ...payload,
            Updated: Math.max(payload.Updated || 0, (prevData === null || prevData === void 0 ? void 0 : prevData.Updated) || 0)
        };
        const indexToInsertOrUpdate = prevIndex !== -1 ? prevIndex : prevProjects.length;
        return set(state, `[${NAMESPACE}].data[${payload.WorkSpaceId}].Projects[${indexToInsertOrUpdate}]`, resultData, {
            checkExistence: true,
            checkEqual: true
        });
    },
    [projectsActionTypes.DELETE_PROJECT_COMPLETED]: (state, { meta }) => {
        var _a;
        return set(state, `[${NAMESPACE}].data[${meta.workSpaceId}].Projects`, reject((_a = state[NAMESPACE].data[meta.workSpaceId]) === null || _a === void 0 ? void 0 : _a.Projects, ["Id", meta.projectId]), {
            checkExistence: true,
            checkEqual: false
        });
    },
    [documentEditorActionTypes.SAVE_DOCUMENT_COMPLETED]: (state, { payload }) => {
        const currentProject = find(flatMap(values(state[NAMESPACE].data), "Projects"), [
            "Id",
            payload.ProjectId
        ]);
        if (!currentProject ||
            !currentProject.WorkSpaceId ||
            !state[NAMESPACE].data[currentProject.WorkSpaceId])
            return state;
        const projects = state[NAMESPACE].data[currentProject.WorkSpaceId].Projects;
        if (!projects)
            return state;
        const projectIndex = findIndex(projects, ["Id", payload.ProjectId]);
        if (projectIndex === -1)
            return state;
        const project = projects[projectIndex];
        const documents = project.Documents;
        if (!project || !documents)
            return state;
        const documentIndex = findIndex(documents, ["Id", payload.Id]);
        const indexToInsertOrUpdate = documentIndex !== -1 ? documentIndex : documents.length;
        const result = set(state, `[${NAMESPACE}].data[${currentProject.WorkSpaceId}].Projects[${projectIndex}].Documents[${indexToInsertOrUpdate}]`, payload, {
            checkExistence: false,
            checkEqual: true
        });
        return set(result, `[${NAMESPACE}].data[${currentProject.WorkSpaceId}].Projects[${projectIndex}].Updated`, Math.max(project.Updated, payload.Updated));
    },
    [documentEditorActionTypes.DUPLICATE_DOCUMENT_COMPLETED]: (state, { payload }) => {
        const currentProject = find(flatMap(values(state[NAMESPACE].data), "Projects"), [
            "Id",
            payload.ProjectId
        ]);
        if (!currentProject ||
            !currentProject.WorkSpaceId ||
            !state[NAMESPACE].data[currentProject.WorkSpaceId])
            return state;
        const projects = state[NAMESPACE].data[currentProject.WorkSpaceId].Projects;
        if (!projects)
            return state;
        const projectIndex = findIndex(projects, ["Id", payload.ProjectId]);
        if (projectIndex === -1)
            return state;
        const project = projects[projectIndex];
        const documents = projects[projectIndex].Documents;
        if (!project || !documents)
            return state;
        const indexToInsert = documents.length || 0;
        const result = set(state, `[${NAMESPACE}].data[${currentProject.WorkSpaceId}].Projects[${projectIndex}].Documents[${indexToInsert}]`, payload, {
            checkExistence: false,
            checkEqual: true
        });
        return set(result, `[${NAMESPACE}].data[${currentProject.WorkSpaceId}].Projects[${projectIndex}].Updated`, Math.max(project.Updated, payload.Updated));
    },
    [documentsActionTypes.DELETE_DOCUMENT_COMPLETED]: (state, { meta }) => {
        var _a, _b, _c, _d;
        const project = find(flatMap(values(state[NAMESPACE].data), "Projects"), [
            "Id",
            meta.projectId
        ]);
        if (!project)
            return state;
        const projectIndex = findIndex((_a = state[NAMESPACE].data[project.WorkSpaceId]) === null || _a === void 0 ? void 0 : _a.Projects, [
            "Id",
            meta.projectId
        ]);
        return set(state, `[${NAMESPACE}].data[${project.WorkSpaceId}].Projects[${projectIndex}].Documents`, reject((_d = (_c = (_b = state[NAMESPACE].data[project.WorkSpaceId]) === null || _b === void 0 ? void 0 : _b.Projects) === null || _c === void 0 ? void 0 : _c[projectIndex]) === null || _d === void 0 ? void 0 : _d.Documents, [
            "Id",
            meta.documentId
        ]), {
            checkExistence: true,
            checkEqual: false
        });
    }
});
